import { faDownload, faEllipsisVertical, faFileExcel, faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { Card, Dropdown, Spinner, Table } from 'react-bootstrap';
import DownloadQpService from '../../services/downloadQp.service';
import moment from 'moment';
import Skeleton from 'react-loading-skeleton';
import CustomToggle from '../../Menu/CustomMenu';
import toast from 'react-hot-toast';

const download = require("downloadjs");

export default function QPDownloadIndex() {

    const [questionPaper, setQuestionPaper] = useState<any>();
    const [loading, setLoading] = useState<boolean>(false);

    const getAllCreatedQuestionPapers = async () => {
        setLoading(true);
        await DownloadQpService.getAllQPForUser().then(res => {
            if (res.status === 200) {
                setQuestionPaper(res.data)
            }
        })
            .catch(err => {
                console.log(err)
            })
            .finally(() => {
                setLoading(false);
            })
    }

    const downloadQuestionPaperZip = async (qp_id: any) => {
        await DownloadQpService.getQuestionPaperZip(qp_id).then(res => {
            if (res.status === 200) {
                download(res.data, "qp.zip", "application/zip");
            }
        })
    }


    const handleQuestionPaperDownload = async (questionId: any) => {
        toast.promise(DownloadQpService.downloadQuestionPaper(questionId).then((res) => {
            if (res.status === 200) {
                const a = document.createElement('a');
                a.href = res.data;
                a.download = `QuestionPaper_${questionId}.zip`;
                document.body.appendChild(a);
                a.click();

                document.body.removeChild(a);
            }
        }), {
            loading: 'Downloading...',
            success: 'File downloaded',
            error: 'Unable to download this file.',
        });
    }






    useEffect(() => {
        getAllCreatedQuestionPapers()
    }, [])

    if (loading) {
        return (
            <Skeleton height={600} />
        )
    }

    return (
        <>
            <div className="mt-2">
                <Card className="reg-card bg-white">
                    <Card.Body>

                        <Table striped hover>
                            <thead>
                                <tr>
                                    <th>
                                        S.No.
                                    </th>
                                    <th>
                                        ExamId
                                    </th>
                                    <th>
                                        ShiftId
                                    </th>
                                    <th>
                                        Question Paper Id
                                    </th>
                                    <th>
                                        CreatedAt
                                    </th>
                                    <th>
                                        Actions
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    loading ? <tr><td colSpan={5} className="text-center">Loading... <Spinner animation="border" variant="primary" /> </td></tr> :
                                        questionPaper && questionPaper.length > 0 && questionPaper.map((data: any, index: number) => {
                                            return (
                                                <tr>
                                                    <td className='fw-bold '>
                                                        {index + 1}
                                                    </td>
                                                    <td>
                                                        {data.examId}
                                                    </td>
                                                    <td>
                                                        {data.shiftId}
                                                    </td>
                                                    <td>
                                                        {data._id}
                                                    </td>
                                                    <td>
                                                        {moment(data.createdAt).format("DD/MM/YYYY hh:mm a")}
                                                    </td>
                                                    <td>
                                                        <Dropdown>
                                                            <Dropdown.Toggle
                                                                as={CustomToggle}
                                                                id="dropxdown-custom-components"
                                                            >
                                                                <FontAwesomeIcon
                                                                    icon={faEllipsisVertical}
                                                                    className="text-primary xcn-link-pointer"
                                                                />
                                                            </Dropdown.Toggle>

                                                            <Dropdown.Menu>
                                                                {/* <Dropdown.Item className="text-secondary">
                                                                    <FontAwesomeIcon className="me-2 text-danger" icon={faFilePdf} />
                                                                    Download as PDF
                                                                </Dropdown.Item>
                                                                <Dropdown.Divider /> */}
                                                                <Dropdown.Item className="text-secondary" onClick={() => handleQuestionPaperDownload(data._id)}>
                                                                    <FontAwesomeIcon className="me-2 text-success" icon={faFileExcel} />
                                                                    Download as Excel
                                                                </Dropdown.Item>
                                                            </Dropdown.Menu>
                                                        </Dropdown>
                                                    </td>
                                                </tr>
                                            )
                                        })}
                            </tbody>
                        </Table>
                    </Card.Body>
                </Card>
            </div>
        </>
    )
}